import { z } from 'zod';

export const dateSchema = z.date();

// Custom validation to ensure no timezone is present
export const datetimeLocalSchema = z
  .iso
  .datetime({ local: true })
  .refine(
    (value) => !value.endsWith('Z') && !value.match(/[+-]\d{2}:?\d{2}$/),
    { message: 'Datetime string must not contain timezone information' },
  );

export const modelSchema = z
  .object({
    id: z.guid(),
    createdAt: dateSchema,
    updatedAt: dateSchema,
  })
  .strict();

export const createSchema = z.object({}).strict();
